import { render, staticRenderFns } from "./CrisisSideBar.vue?vue&type=template&id=905c28b8&scoped=true&"
import script from "./CrisisSideBar.vue?vue&type=script&lang=js&"
export * from "./CrisisSideBar.vue?vue&type=script&lang=js&"
import style0 from "./CrisisSideBar.vue?vue&type=style&index=0&id=905c28b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905c28b8",
  null
  
)

export default component.exports